module.exports = __webpack_public_path__ + "img/icon-pass.png";